import BasicPopover from './components/BasicPopover';

export const financeColumns = [
  {
    Header: 'Property Type',
    accessor: 'propertyType',
    align: 'left',
    disableSortBy: true,
  },
  {
    Header: 'Account No',
    accessor: 'lastFourDigits',
    align: 'left',
    disableSortBy: true,
  },
  {
    Header: 'Routing No',
    accessor: 'routingNumber',
    align: 'left',
    disableSortBy: true,
  },
  {
    Header: 'Status',
    accessor: 'isVerified',
    align: 'center',
    disableSortBy: true,
  },
  {
    Header: 'Action',
    accessor: 'action',
    align: 'center',
    disableSortBy: true,
  },
];

export const financeRows = (rowData, fetchPropertyTypeBankDetails) => {
  return rowData.map((raw) => {
    const { id, lastFourDigits, routingNumber, isVerified, propertyType } = raw;
    return {
      propertyType: propertyType,
      lastFourDigits: `*****${lastFourDigits}`,
      routingNumber: routingNumber,
      isVerified: isVerified ? (
        'Verified'
      ) : (
        <span style={{ color: 'red' }}>Unverified</span>
      ),
      action: isVerified ? (
        '-'
      ) : (
        <BasicPopover
          id={id}
          fetchPropertyTypeBankDetails={fetchPropertyTypeBankDetails}
          isVerified={isVerified}
        />
      ),
    };
  });
};
